/* eslint-disable import/no-unresolved */
/* eslint-disable no-unused-vars */
import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import Header from './header';
import Nav, { NAV_WIDTH_CLOSED } from './nav';
import { IconButton } from '@mui/material';
import Iconify from 'src/components/iconify/Iconify';
import Notifications from 'src/components/Notifications';
import { useAuth } from 'src/utils/AuthContext';
import LiveClock from 'src/components/clock/LiveClock';
import { useApp } from 'src/utils/AppContext';
import { showsNotificationBell } from 'src/utils/orgFeatures';

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 40;
const APP_BAR_DESKTOP = 50;
// const APP_BAR_MOBILE = 64;
// const APP_BAR_DESKTOP = 92;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  background: theme.palette.background.default,
  // paddingTop: APP_BAR_MOBILE + 24,
  // paddingBottom: theme.spacing(10),
  // paddingLeft: theme.spacing(2),
  // paddingRight: theme.spacing(2),
  [theme.breakpoints.up('lg')]: {
    // paddingTop: theme.spacing(2),
    // paddingBottom: theme.spacing(2),
    // paddingTop: APP_BAR_DESKTOP + 24,
    // paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const { authStatus } = useAuth();
  const { settings, id: orgId, name: orgName } = useApp();

  return (
    <StyledRoot>
      <IconButton
        onClick={() => setOpen(true)}
        sx={{
          position: 'fixed',
          top: '0rem',
          left: '0rem',
          margin: '0.5rem',
          color: 'text.primary',
          display: { lg: 'none' },
        }}
      >
        <Iconify icon="eva:menu-2-fill" />
      </IconButton>
      {/* Graviti's notification bell was flagged during their FDA audit — hidden for Graviti only. */}
      {authStatus === 'SignedIn' && showsNotificationBell(orgId, orgName) && <Notifications />}
      {/* <Header onOpenNav={() => setOpen(true)} /> */}
      <Nav openNav={open} setOpenNav={setOpen} onCloseNav={() => setOpen(false)} />
      <Main>
        <Outlet />
      </Main>
      {settings?.liveClock && <LiveClock />}
    </StyledRoot>
  );
}
